// Selects which web barcode-scanning engine the app uses.
//
//   - 'strich' : @pixelverse/strichjs-sdk. Requires VITE_STRICH_LICENSE_KEY.
//     Best decode quality (esp. GS1 DataBar Expanded), paid.
//   - 'zxing'  : @zxing/browser. No licence, supports most common 1D/2D
//     symbologies; GS1 DataBar Expanded is best-effort (the underlying
//     library flags it as not production-ready).
//
// Selection is build-time via VITE_SCANNER_ENGINE. Default 'zxing' so a
// deploy with no env vars at all still scans.
//
// Ported verbatim from waio-inventory (src/lib/scannerEngine.ts) — keep in sync.

const engineEnv = import.meta.env.VITE_SCANNER_ENGINE as string | undefined
const strichKey = import.meta.env.VITE_STRICH_LICENSE_KEY as string | undefined

export type ScannerEngine = 'strich' | 'zxing'

function pickEngine(): ScannerEngine {
  if (engineEnv === 'strich') {
    if (strichKey) return 'strich'
    if (typeof window !== 'undefined') {
      console.warn(
        '[scanner] VITE_SCANNER_ENGINE=strich but VITE_STRICH_LICENSE_KEY is not set — falling back to zxing.',
      )
    }
    return 'zxing'
  }
  return 'zxing'
}

export const scannerEngine: ScannerEngine = pickEngine()
